<h1>Reset Password</h1>

<form (ngSubmit)="resetPassword()">
  <div class="form-group">
    <label for="password">New Password</label>
    <input
      type="password"
      class="form-control"
      id="password"
      [(ngModel)]="password"
      name="password"
      required
    />
  </div>

  <button type="submit" class="btn btn-primary">Reset Password</button>
</form>
